import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@/components/global/ProtectedRoute';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Fallback } from '@/pages/Fallback';
import { GoogleMapsProvider } from '@/providers/GoogleMapsProvider';
import { AuthRoutes } from '@/routes/AuthRoutes';
import { DashboardRoutes } from '@/routes/DashboardRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 3 * 60 * 1000,
    },
  },
});
export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <GoogleMapsProvider>
        <TooltipProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
            <Route path="/:orgId/auth/*" element={<AuthRoutes />} />
            <Route path="/auth/*" element={<AuthRoutes />} />

            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <DashboardRoutes />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Fallback />} />
          </Routes>
          <Toaster />
        </TooltipProvider>
      </GoogleMapsProvider>
    </QueryClientProvider>
  );
};
